


















































































import FormContainer from '../mixins/form-container'
import PairRow from '@/components/PairRow.vue'
import certificadoService from '../services/certificados'
import Worker from '@/components/Worker.vue'
import Swal from 'sweetalert2'
import { downloadBlob, makeTimeId } from '../util'

export default FormContainer.extend({
  components: {
    PairRow,
    Worker,
  },
  data: () => ({
    dni: '',
    fileURL: '',
    working: false,
    anio: '2025',
    id: 0,
    poster: false,
    descargar: false,
  }),

  methods: {
    submit() {
      return certificadoService
        .pdf({ dni: this.dni, anio: this.anio }, this.id)
        .then(
          async response => {
            if (response.error) {
              Swal.fire('Error', response.error, 'error')
            }
            const file = new Blob([response.data], {
              type: 'application/pdf',
            })
            this.fileURL = URL.createObjectURL(file)

            const res = await downloadBlob(
              file,
              `CACIED_2025-${this.dni}_${makeTimeId()}.pdf`
            )
            this.descargar = true
          },
          async (err: any) => {
            await Swal.fire({
              title: 'ADVERTENCIA',
              text: 'No fue posible generar el certificado, puede que no se encuentre registrado o sus datos esten incompletos, ¿desea continuar con el registro?',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Continuar',
              cancelButtonText: 'Cancelar',
              reverseButtons: true,
            }).then(result => {
              if (result.isConfirmed) {
                this.$router.push('/registro')
              }
            })
          }
        )
    },
  },

  created() {
    let info: any = window.location.href.split('?')

    info = info[1]
    if (info != undefined) {
      info = info.split('-')
      this.id = info[1]
      this.dni = info[0]
      this.anio = info[2]
      if (this.id != 0 && this.dni != '') {
        this.poster = true
      }
    }
  },
})
